import { SearchIcon } from '@/components/icons'
import { platformBlock, platformMeta } from '@/blocks/platform-tools'
import type { BlockConfig, BlockMeta } from '@/blocks/types'
import { AuthMode, IntegrationType } from '@/blocks/types'

const DataForSEOBlockOriginal: BlockConfig = {
  type: 'dataforseo',
  name: 'DataForSEO',
  description: 'Read keyword ideas, search volume, CPC and competition',
  authMode: AuthMode.ApiKey,
  category: 'tools',
  integrationType: IntegrationType.Search,
  bgColor: 'var(--text-tertiary)',
  icon: SearchIcon,
  subBlocks: [
    {
      id: 'operation',
      title: 'Operation',
      type: 'dropdown',
      value: () => 'keyword_ideas',
      options: [
        { id: 'keyword_ideas', label: 'Keyword Ideas' },
        { id: 'search_volumes', label: 'Search Volumes' },
      ],
    },
    {
      id: 'apiKey',
      title: 'Base64 login:password',
      type: 'short-input',
      password: true,
      required: true,
    },
    { id: 'parameters', title: 'Parameters (JSON)', type: 'code', required: true },
  ],
  tools: {
    access: ['dataforseo_keyword_ideas', 'dataforseo_search_volumes'],
    config: {
      params: (p) => ({
        apiKey: p.apiKey,
        parameters:
          typeof p.parameters === 'string' ? JSON.parse(p.parameters || '{}') : p.parameters,
      }),
      tool: (p) => `dataforseo_${p.operation || 'keyword_ideas'}`,
    },
  },
  inputs: {
    apiKey: { type: 'string', description: 'API key' },
    parameters: { type: 'string', description: 'JSON request parameters' },
  },
  outputs: { data: { type: 'json', description: 'Provider data' } },
}
const DataForSEOBlockMetaOriginal = { tags: ['marketing'], templates: [] } satisfies BlockMeta

export const DataForSEOBlock = platformBlock(DataForSEOBlockOriginal)
export const DataForSEOBlockMeta = platformMeta(DataForSEOBlockMetaOriginal)
